import { useEffect, useRef, useState } from "react";
import useAuth from "../hook/useAuth";
import UsernameValidatedComponent from "./UsernameValidatedComponent";
import { DoesEmailExist, DoesUserNameExist, getUserByEmail, post_User } from "../services/Users";
import EmailValidatedToCheckExistComponent from "./EmailValidatedToCheckExistComponent";
import PasswordValidation from "./PasswordValidation";
import { onChangePhoneNumber } from "../utils/phoneNumberRegex";
import { getCourseCategoriesWithPublishCourses } from "../services/Course";
import { post_Child } from "../services/Parent";
import { PleasewaitPopup } from "./PleasewaitPopup";


type AddChildProps = {
    showPopup: boolean;
    setShowPopup: (value: boolean) => void;
    setRefreshChildList: (value: boolean) => void;
}



export const AddChild = ({ showPopup, setShowPopup, setRefreshChildList }: AddChildProps) => {
    const { auth }: any = useAuth();
    const [currentStep, setCurrentStep] = useState<number>(1);
    const [isChildHaveAccount, setIsChildHaveAccount] = useState<boolean>(true);
    const [selectedCourse, setSelectedCourse] = useState<number>(0);
    const [filterCourseList, setFilterCourseList] = useState<any[]>([]);
    const [filterCourseSearchValue, setFilterCourseSearchValue] = useState<string>("");
    const [courseList, setCourseList] = useState<any[]>([]);
    const [courseDataLoaded, setCourseDataLoaded] = useState<boolean>(false);
    const [email, setEmail] = useState<string>("");
    const [emailIsValid, setEmailIsValid] = useState<boolean>(false);
    const inputRef = useRef<HTMLInputElement>(null);
    const [firstName, setFirstName] = useState<string>("");
    const [lastName, setLastName] = useState<string>("");
    const [userName, setUserName] = useState<string>("");
    const [usernameTouched, setUsernameTouched] = useState<boolean>(false);
    const [isUserNameExist, setIsUserNameExist] = useState<boolean | null>(null);
    const [emailAddress, setEmailAddress] = useState<string>("");
    const [emailTouched, setEmailTouched] = useState<boolean>(false);
    const [isEmailExist, setIsEmailExist] = useState<boolean | null>(null);
    const [phoneNumber, setPhoneNumber] = useState<string>("");
    const [password, setPassword] = useState<string>("");
    const [passwordTouched, setPasswordTouched] = useState<boolean>(false);
    const [isPasswordValid, setIsPasswordValid] = useState<boolean>(false);
    const [isChildInfoValid, setIsChildInfoValid] = useState<boolean>(false);
    const [showPleasewait, setShowPleasewait] = useState<boolean>(false);

    useEffect(() => {
        if (showPopup) {
            document.body.classList.add("overflow-hidden");
        } else {
            document.body.classList.remove("overflow-hidden");
        }

        return () => {
            document.body.classList.remove("overflow-hidden");
        };
    }, [showPopup]);

    const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = e.target;
        setEmail(value);
        const isValid = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,}$/gm.test(value);
        e.target.setCustomValidity(isValid ? "" : "Please enter a valid email");
        setEmailIsValid(isValid);
    };

    useEffect(() => {
        if (firstName.trim() && lastName.trim() && emailAddress.trim() && phoneNumber.trim() && password.trim()) {
            const isValid = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,}$/gm.test(emailAddress.trim());
            const isValidPassword =
                password.trim().length >= 8 &&
                /\d/.test(password.trim()) &&
                /[a-z]/.test(password.trim()) &&
                /[A-Z]/.test(password.trim()) &&
                /[!@#$%^&*(),.?":{}|<>]/.test(password.trim());
            if (isValid && isValidPassword && !isUserNameExist && !isEmailExist) {
                setIsChildInfoValid(true)
            }
            else {
                setIsChildInfoValid(false)
            }
        }
        else {
            setIsChildInfoValid(false);
        }
    }, [firstName, lastName, emailAddress, phoneNumber, password, isEmailExist, isUserNameExist])




    useEffect(() => {

        const filteredCourses = courseList
            .map((category) => ({
                ...category,
                courses: category.courses.filter((course: any) =>
                    course?.title.toLowerCase().includes(filterCourseSearchValue.toLowerCase())
                ),
            }))
            .filter((category) => category.courses.length > 0);

        setFilterCourseList(filteredCourses)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filterCourseSearchValue])

    if (!showPopup) return null;

    const isInvalid = () => {
        if (currentStep === 1) return false;
        if (currentStep === 2 && isChildHaveAccount && emailIsValid) return false;
        if (currentStep === 2 && !isChildHaveAccount && isChildInfoValid) return false;
        if (currentStep === 3 && selectedCourse > 0) return false;

        return true;
    }

    const handleNextClick = () => {
        if (currentStep === 1) {
            setCurrentStep(2);
        }
        else if (currentStep === 2) {
            setCurrentStep(3)
            setCourseDataLoaded(false);
            getCourseCategoriesWithPublishCourses()
                .then((data) => {
                    const list = data?.filter((category: any) => category?.courses?.length > 0)?.map((category: any) => {
                        return {
                            ...category,
                            courses: category?.courses?.map((item: any) => {
                                return {
                                    ...item,
                                }
                            })
                        }
                    })

                    setCourseList(list);
                    setFilterCourseList(list);
                    setCourseDataLoaded(true);
                })
                .catch((error) => {
                    setCourseList([]);
                    setFilterCourseList([]);
                    setCourseDataLoaded(true);
                    console.error(error)
                })
        }
        else if (currentStep === 3) {
            if (isChildHaveAccount) {
                setShowPleasewait(true);
                getUserByEmail(email, 0, 1)
                    .then((data) => {
                        if (data.count === 1 && data.userReport?.length === 1) {
                            post_Child({
                                parentId: auth?.id,
                                childId: data.userReport[0]?.id,
                                courseId: selectedCourse,
                                emailAddress: "",
                                createdAt: new Date().toLocaleString(),
                            }, auth?.id)
                                .then((data) => {
                                    setShowPleasewait(false);
                                    setShowPopup(false);
                                    setRefreshChildList(true);
                                })
                                .catch((error) => {
                                    console.error(error);
                                })
                        }
                        else {
                            post_Child({
                                parentId: auth?.id,
                                childId: 0,
                                courseId: selectedCourse,
                                emailAddress: email,
                                createdAt: new Date().toLocaleString(),
                            }, auth?.id)
                                .then((data) => {
                                    setShowPleasewait(false);
                                    setShowPopup(false);
                                    setRefreshChildList(true);
                                })
                                .catch((error) => {
                                    console.error(error);
                                })
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                    })
            }
            else {
                setShowPleasewait(true);
                post_User({
                    firstName,
                    lastName,
                    userName,
                    emailAddress,
                    mobilPhoneNumber: phoneNumber,
                    password: password,
                    forcePasswordChange: true,
                    isActive: true,
                    dateFormat: "MM/dd/yyyy",
                    language: "English",
                    bio: "",
                    profilePic: "",
                    roleId: 5,
                    lastLogin: "",
                    createdAt: new Date(),
                    createdBy: auth?.givenname,
                    updatedAt: "",
                    updatedBy: ""
                })
                    .then((id: number) => {
                        post_Child({
                            parentId: auth?.id,
                            childId: id,
                            courseId: selectedCourse,
                            emailAddress: "",
                            createdAt: new Date().toLocaleString(),
                        }, auth?.id)
                            .then((res) => {
                                setShowPleasewait(false);
                                setShowPopup(false);
                                setRefreshChildList(true);
                            })
                    })
                    .catch((error) => {
                        console.error(error);
                    })
            }


        }
    }

    const handleBackClick = () => {
        if (currentStep === 2) {
            setCurrentStep(1);
        }
        else if (currentStep === 3) {
            setCurrentStep(2);
        }
    }

    return (
        <>
            <div className="fixed inset-0 z-[9999999] flex items-center justify-center bg-black/50 p-10">
                <div className="bg-white w-full max-w-3xl rounded-md shadow-lg flex flex-col">

                    <div className="px-6 py-4 border-b w-full flex justify-between items-center">
                        <h2 className="text-lg font-medium">Add child</h2>
                        <button
                            onClick={() => {
                                setShowPopup(false)

                            }}
                            className="text-gray-500"
                        >
                            <span className="material-symbols-outlined text-2xl">
                                close
                            </span>
                        </button>
                    </div>

                    {
                        currentStep === 1 && (
                            <div className="p-4">
                                <p className="text-gray-800 mb-3">
                                    Does your child already have an account?
                                </p>

                                <div className="space-y-2">
                                    <label className="flex items-center space-x-2 cursor-pointer">
                                        <input
                                            type="radio"
                                            name="childAccount"
                                            value="yes"
                                            checked={isChildHaveAccount}
                                            onChange={(e) => setIsChildHaveAccount(true)}
                                            className="w-4 h-4 text-primary border-gray-300 focus:ring-primary"
                                        />
                                        <span className="text-gray-700">Yes</span>
                                    </label>

                                    <label className="flex items-center space-x-2 cursor-pointer">
                                        <input
                                            type="radio"
                                            name="childAccount"
                                            value="no"
                                            checked={!isChildHaveAccount}
                                            onChange={(e) => setIsChildHaveAccount(false)}
                                            className="w-4 h-4 text-primary border-gray-300 focus:ring-primary"
                                        />
                                        <span className="text-gray-700">No</span>
                                    </label>
                                </div>
                            </div>

                        )
                    }

                    {
                        (currentStep === 2 && isChildHaveAccount) && (
                            <div className="px-6 py-6 space-y-2">
                                <p className="text-gray-800 mb-3">
                                    Please enter your child email.
                                </p>

                                <div>
                                    <input
                                        ref={inputRef}
                                        name="email"
                                        type="email"
                                        placeholder="Email"
                                        required
                                        className="w-full mt-2 border rounded px-3 py-2 text-sm focus:outline-none focus:ring focus:ring-primary"
                                        value={email}
                                        onChange={handleEmailChange}
                                    />
                                </div>
                            </div>
                        )
                    }


                    {
                        (currentStep === 2 && !isChildHaveAccount) && (
                            <div className="px-6 py-6 space-y-2">
                                <div className="md:flex justify-between items-center w-full">
                                    <div>
                                        <label className="font-medium">First Name*</label>
                                        <input
                                            type="text"
                                            placeholder="First Name"
                                            className="w-full mt-2 border rounded px-3 py-2 text-sm focus:outline-none focus:ring focus:ring-primary"
                                            value={firstName}
                                            onChange={(e) => setFirstName(e.target.value)}
                                        />
                                    </div>

                                    <div className="max-md:mt-2">
                                        <label className="font-medium">Last Name*</label>
                                        <input
                                            type="text"
                                            placeholder="Last Name"
                                            className="w-full mt-2 border rounded px-3 py-2 text-sm focus:outline-none focus:ring focus:ring-primary"
                                            value={lastName}
                                            onChange={(e) => setLastName(e.target.value)}
                                        />
                                    </div>
                                </div>

                                <UsernameValidatedComponent
                                    userName={userName}
                                    setUserName={(value) => setUserName(value?.trim())}
                                    getUsername={DoesUserNameExist}
                                    className={{
                                        parentDiv: "",
                                        label: "font-medium",
                                        input: "w-full mt-2 border rounded px-3 py-2 text-sm focus:outline-none focus:ring focus:ring-primary"
                                    }}
                                    touched={usernameTouched}
                                    setTouched={setUsernameTouched}
                                    setIsUserNameExist={setIsUserNameExist}
                                />

                                <EmailValidatedToCheckExistComponent
                                    email={emailAddress}
                                    setEmail={(value) => setEmailAddress(value?.trim())}
                                    getEmail={DoesEmailExist}
                                    className={{
                                        parentDiv: "",
                                        label: "font-medium",
                                        input: "w-full mt-2 border rounded px-3 py-2 text-sm focus:outline-none focus:ring focus:ring-primary"
                                    }}
                                    touched={emailTouched}
                                    setTouched={setEmailTouched}
                                    setIsEmailExist={setIsEmailExist}
                                />

                                <div>
                                    <label className="font-medium">Phone Number*</label>
                                    <input
                                        type='text'
                                        placeholder='Phone No.'
                                        className="w-full mt-2 border rounded px-3 py-2 text-sm focus:outline-none focus:ring focus:ring-primary"
                                        pattern="[\(][0-9]{3}[\)][\s]{1}[0-9]{3}[\-]{1}[0-9]{4}"
                                        value={phoneNumber}
                                        onChange={(e) => setPhoneNumber(onChangePhoneNumber(e, e.target.value) || "")}
                                    />
                                </div>


                                <PasswordValidation
                                    password={password}
                                    setPassword={(value) => setPassword(value?.trim())}
                                    isValid={isPasswordValid}
                                    setIsValid={setIsPasswordValid}
                                    className={{
                                        parentDiv: "relative",
                                        label: "font-medium",
                                        input: "w-full mt-2 border rounded px-3 py-2 text-sm focus:outline-none focus:ring focus:ring-primary"
                                    }}
                                    touched={passwordTouched}
                                    setTouched={setPasswordTouched}
                                />

                            </div>
                        )
                    }

                    {
                        (currentStep === 3 && (isChildInfoValid || emailIsValid)) && (
                            <div className="px-6 py-6 overflow-y-auto flex-1">
                                <h3 className="text-lg font-medium mb-2">
                                    Which course do you want your child to work on?
                                </h3>
                                <p className="text-sm text-gray-600 mb-4">
                                    Once you add a course, your child will see it on their dashboard and
                                    can begin learning right away.
                                </p>

                                {/* Search box */}
                                <input
                                    type="text"
                                    placeholder="Search for a course"
                                    className="w-full border rounded px-3 py-2 mb-6 text-sm focus:outline-none focus:ring focus:ring-primary"
                                    value={filterCourseSearchValue}
                                    onChange={(e) => setFilterCourseSearchValue(e.target.value)}
                                />

                                {/* Course categories */}
                                <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
                                    {filterCourseList?.map((item: any, index: number) => (
                                        <div key={index}>
                                            <h4 className="font-medium border-b pb-1 mb-2 uppercase">{item?.name}</h4>
                                            <div className="space-y-2">
                                                {item?.courses?.map((course: any, idx: number) => (
                                                    <label
                                                        key={idx}
                                                        className="flex items-center space-x-2 text-sm cursor-pointer"
                                                    >
                                                        <input
                                                            type="radio"
                                                            name="course"
                                                            value={course?.id}
                                                            checked={selectedCourse === course?.id}
                                                            onChange={() => setSelectedCourse(course?.id)}
                                                        />
                                                        <span>{course?.title}</span>
                                                    </label>
                                                ))}
                                            </div>
                                        </div>
                                    ))}


                                </div>
                                {
                                    !courseDataLoaded && (
                                        <div className="flex items-center justify-center w-full p-2">
                                            <div className="mb-4 h-8 w-8 animate-spin rounded-full border-4 border-gray-300 border-t-primary" />
                                        </div>
                                    )
                                }

                                {
                                    (courseDataLoaded && filterCourseList.length === 0) && (
                                        <div className="flex items-center justify-center w-full p-2">
                                            <span className="text-lg text-gray-400">No course found!</span>
                                        </div>
                                    )
                                }
                            </div>
                        )
                    }



                    {/* Footer */}
                    <div className="px-6 py-4 border-t flex justify-between space-x-3">
                        <button
                            className={`px-6 py-2 ${currentStep > 1 ? "bg-primary text-white cursor-pointer" : "bg-gray-300 text-white cursor-not-allowed"}  font-medium rounded`}
                            disabled={currentStep > 1 ? false : true}
                            onClick={handleBackClick}
                        >
                            Back
                        </button>

                        <button
                            className={`px-6 py-2 ${isInvalid() ? "bg-gray-300 text-white cursor-not-allowed" : "bg-primary text-white cursor-pointer"}  font-medium rounded`}
                            disabled={isInvalid()}
                            onClick={handleNextClick}
                        >
                            {currentStep === 3 ? "Invite" : "Next"}
                        </button>
                    </div>
                </div>
            </div >
            <PleasewaitPopup showPopup={showPleasewait} />
        </>
    )
}